"use client";

import type { MutationOptions } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import gql from "graphql-tag";
import type { GeneratedMutation } from "@aws-amplify/api-graphql";
import { fetchGraphQLClientWithApiKey } from "../../../amplify/fetchGraphQLClient";

export interface NonEligibleUser {
  email: string;
  submittedAt: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  howDidYouHearFromUs?: string;
}

export interface AddNonEligibleUserInput {
  email: string;
  submittedAt: string;
  firstName?: string;
  lastName?: string;
  dateOfBirth?: string;
  howDidYouHearFromUs?: string;
}

interface AddNonEligibleUserMutationVariables {
  input: AddNonEligibleUserInput;
}

interface AddNonEligibleUserMutationResponseType {
  data?: {
    addNonEligibleUser: NonEligibleUser;
  };
}

export const addNonEligibleUserMutation = gql`
  mutation addNonEligibleUser($input: AddNonEligibleUserInput!) {
    addNonEligibleUser(input: $input) {
      email
      submittedAt
      firstName
      lastName
      dateOfBirth
      howDidYouHearFromUs
    }
  }
`.loc?.source.body as GeneratedMutation<
  AddNonEligibleUserMutationVariables,
  {
    addNonEligibleUser: NonEligibleUser;
  }
>;

export const useAddNonEligibleUser = (
  options: MutationOptions<
    AddNonEligibleUserMutationResponseType,
    Error,
    AddNonEligibleUserMutationVariables
  > = {}
) => {
  return useMutation<
    AddNonEligibleUserMutationResponseType,
    Error,
    AddNonEligibleUserMutationVariables
  >({
    ...options,
    mutationFn: async (variables) =>
      fetchGraphQLClientWithApiKey(addNonEligibleUserMutation, variables),
  });
};
